angular.module('dpw.services')

    /**
     * Utilities for wizard creation and manipulation.
     */
    .factory('wizard', ['$rootScope', 'popup', function ($rootScope, popup) {
        var wizard = {

            /**
             * Create a wizard
             *
             * @param {Object} config               - Configuration for the wizard
             * @param {String} config.name          - Will be used as key name to store the wizard instance
             * @param {String} config.extraClass    - Will be appended to the root element of the wizard
             * @returns {Wizard}                    - Wizard instance for later manipulation
             *
             * @Note
             * Please refer to the documentation of directive `dpw-wizard` for complete wizard configuration guide.
             */
            create: function (config) {
                var wizardInstance = new Wizard(config);
                var wizardName = config.name;

                if (wizardName) {
                    this.instances[wizardName] = wizardInstance;
                }

                return wizardInstance;
            },

            instances: {}

        };

        /**
         * Wizard Class
         * @constructor
         */
        var Wizard = function (config) {
            this.config = config;
            this._render();
        };

        _.assign(Wizard.prototype, {
            close: function () {
                this.scope.$destroy();
            },

            _render: function () {
                this.scope = $rootScope.$new();
                this.scope.config = this.config;

                _.assign(this.scope.config, {
                    close: _.bind(this.close, this)
                });

                var rootClass = RCDPW.isAdminSite ? 'admin' : 'my-account';
                var wizardClass = this.config.extraClass;

                popup({
                    scope: this.scope,
                    directiveName: 'dpw-wizard',
                    extraClass: ['popup-auto-width', 'console-ui', rootClass, wizardClass].join(' '),
                    showHeader: false
                });
            }
        });

        return wizard;
    }])

;